import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setModalVisible } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      isVisible: localState.isModalVisible
    };
  };
};

const mapDispatchToProps = (dispatch, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setModalVisible(getEntityRef(props), false))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
